import {CommonTranslKey} from "../CommonTranslKey";
import {useTranslation} from "react-i18next";
import {ActionButton, ActionButtonProps} from "@dain/mui-components";
import {Add, Delete, Description} from "@mui/icons-material";

type CommonActionButtonProps = Omit<ActionButtonProps, "tooltip" | "icon">;

export function AddActionButton(props: CommonActionButtonProps) {
    const {t} = useTranslation();
    return (
        <ActionButton tooltip={t(CommonTranslKey.ADD)} icon={<Add/>} {...props}></ActionButton>
    );
}

export function DeleteActionButton(props: CommonActionButtonProps) {
    const {t} = useTranslation();
    return (
        <ActionButton tooltip={t(CommonTranslKey.DELETE)} icon={<Delete/>} {...props}></ActionButton>
    );
}

export function DetailActionButton(props: CommonActionButtonProps) {
    const {t} = useTranslation();
    return (
        <ActionButton tooltip={t(CommonTranslKey.SHOW_DETAILS)} icon={<Description/>} {...props}></ActionButton>
    );
}
